import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Breadcrumb, Space, Typography } from 'antd';
import { Link } from 'react-router-dom';
const { Title } = Typography;
export function PageHeader({ title, breadcrumb, actions, avatar }) {
    return (_jsxs("div", { className: "admin-page-header", style: { marginBottom: 16 }, children: [breadcrumb && breadcrumb.length > 0 && (_jsx(Breadcrumb, { items: breadcrumb.map((b) => {
                    if (typeof b === 'string')
                        return { title: b };
                    return { title: b.to ? _jsx(Link, { to: b.to, children: b.label }) : b.label };
                }), style: { marginBottom: 8 } })), _jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 12 }, children: [avatar && _jsx("div", { style: { flex: '0 0 auto' }, children: avatar }), _jsx(Title, { level: 3, style: { margin: 0, flex: 1 }, children: title }), actions && _jsx(Space, { children: actions })] })] }));
}
